import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getPageById } from "./Services";

export const useGetPageDetailsById= (pageId:string) => {
  return useQuery(
    [endpoints.getPageById,pageId],
    () => getPageById(pageId),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};

